import api from '@/api/onboardingManagement'

const state = {

}

const actions = {
  searchQuestion ({ commit }, condition) {
    return api.searchQuestion(condition)
  },
  getQuestionById ({ commit }, id) {
    return api.getQuestionById(id)
  },
  createQuestion ({ commit }, question) {
    return api.createQuestion(question)
  },
  updateQuestion ({ commit }, question) {
    return api.updateQuestion(question)
  },

  searchStep ({ commit }, condition) {
    return api.searchStep(condition)
  },
  getStepById ({ commit }, id) {
    return api.getStepById(id)
  },
  createStep ({ commit }, step) {
    return api.createStep(step)
  },
  updateStep ({ commit }, step) {
    return api.updateStep(step)
  },

  searchQuestionnaire ({ commit }, condition) {
    return api.searchQuestionnaire(condition)
  },
  getQuestionnaireById ({ commit }, id) {
    return api.getQuestionnaireById(id)
  },
  createQuestionnaire ({ commit }, step) {
    return api.createQuestionnaire(step)
  },
  updateQuestionnaire ({ commit }, step) {
    return api.updateQuestionnaire(step)
  },

  searchMicroSite ({ commit }, condition) {
    return api.searchMicroSite(condition)
  },
  getMicroSiteById ({ commit }, id) {
    return api.getMicroSiteById(id)
  },
  createMicroSite ({ commit }, microSite) {
    return api.createMicroSite(microSite)
  },
  updateMicroSite ({ commit }, microSite) {
    return api.updateMicroSite(microSite)
  },

  searchEmailTemplate ({ commit }, condition) {
    return api.searchEmailTemplate(condition)
  },
  getEmailTemplateById ({ commit }, id) {
    return api.getEmailTemplateById(id)
  },
  sendTestEmail ({ commit }, emailTemplate) {
    return api.sendTestEmail(emailTemplate)
  },
  updateEmailTemplate ({ commit }, emailTemplate) {
    return api.updateEmailTemplate(emailTemplate)
  },
  putInvitation ({ commit }, invitation) {
    return api.putInvitation(invitation)
  },
  createInvitation ({ commit }, invitation) {
    return api.createInvitation(invitation)
  },
  createExportOnboardingInvitationTask ({ commit }, invitation) {
    return api.createExportOnboardingInvitationTask(invitation)
  },
  getExportOnboardingInvitationTaskStatus ({ commit }, params) {
    return api.getExportOnboardingInvitationTaskStatus(params)
  },
  exportInvitation ({ commit }, condition) {
    return api.exportInvitation(condition)
  },
  searchInvitation ({ commit }, condition) {
    return api.searchInvitation(condition)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
